<div mat-dialog-title style="display:flex;align-items:center;justify-content:space-between">
  <span>{{ data.titulo }}</span>
  <button mat-icon-button (click)="cancelar()" aria-label="Cerrar" style="flex-shrink:0">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <p *ngIf="data.mensaje">{{ data.mensaje }}</p>
  <form [formGroup]="form">
    <mat-form-field class="w-100">
      <textarea matInput [placeholder]="data.motivoLabel || 'Motivo'" formControlName="motivo" rows="3"></textarea>
      <mat-error *ngIf="form.controls['motivo'].hasError('required')">
        <small>El motivo es <strong>obligatorio</strong></small>
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancelar()">
    <mat-icon>cancel</mat-icon>
    Cancelar
  </button>
  <button mat-stroked-button color="warn" [disabled]="!form.valid" (click)="guardar()" class="ms-2">
    <mat-icon>save</mat-icon>
    Confirmar
  </button>
</mat-dialog-actions>
